
import styled from 'styled-components';
import Link from '@/components/molecules/Link';
import { Svg } from '@/components/styled';
import { BedUnderline, CarUnderline, EuroCurrencyUnderline, FactoryUnderline, ForkliftUnderline, HammerUnderline, HandheartUnderline, HeartHandCare, ICONS, PlateUnderline, SteeringWheelUnderline } from '@/public/img/icons';
import devices from '@/utilities/devices';
import { renderIcons } from '@/utilities/functions';

// #region STYLE
const SectorCardImageContainer = styled(Link)`
	display: block;
	background-color: ${({ theme }) => theme.color.white};
	border-radius: 0.25rem;
	box-shadow: ${({ theme }) => `
		0 0 0.625rem rgba(${theme.color.rgbPrune}, 0.1),
		0 0 3.125rem rgba(${theme.color.rgbPrune}, 0.03),
		0 0 4.375rem rgba(${theme.color.rgbPrune}, 0.02)
	`};
	margin: 0.5rem;
	text-decoration: none;
	transition: .2s;
	width: 12rem;

	.sectordCard-title {
		align-items: center;
		border-bottom: 0.0625rem solid ${({ theme }) => theme.color.grey};
		color: ${({ theme }) => theme.color.prune};
		display: flex;
		font-weight: bold;
		padding: .2rem 1.375rem;

		.text {
			font-size: ${({ theme }) => theme.fontSize.SMALL};
			padding-left: 1rem;
		}
		svg {
			height: 2rem;
			padding: .7em 0 .1em;
			width: 2rem;
		}
	}

	.sectorCard-list {
		color: ${({ theme }) => theme.color.greyDarker};
		font-size: ${({ theme }) => theme.fontSize.XSMALL};
		padding: 1rem 1rem 0 1rem;
	}

	:hover {
		box-shadow: ${({ theme }) => `
		0 0 0.625rem rgba(${theme.color.rgbPrune}, 0.1),
		0 0 3.125rem rgba(${theme.color.rgbPrune}, 0.03),
		0 0 4.375rem rgba(${theme.color.rgbPrune}, 0.02)
	`};
		transform: translateY(-0.1875rem);
	}

	@media screen and (${devices.mobile}) {
		width: 100%;
		margin: 1.4rem 0rem;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		width: 16rem;
	}
`;
const ImageContainer = styled.div<{ backgroundImage: string }>`
		background-image: url(${({ backgroundImage }) => backgroundImage});
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		height: 8.4375rem;
		@media screen and (${devices.mobile}) {
			height: 11.875rem;
		}
		@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
			height: 9.0625rem;
		}
`;
// #endregion

interface SectorCardImageOwnProps {
	icon: ICONS;
	image: {
		alt: string;
		src: string;
	};
	href: string;
	title: string;
}

// #region COMPONENT
const SectorCardImage = ({ icon, image, href, title }: SectorCardImageOwnProps) => {
	return (
		<SectorCardImageContainer href={href}>
			<div className='sectorCard-list'>
				<ImageContainer backgroundImage={image.src} />
			</div>
			<div className='sectordCard-title'>
				<Svg color='prune'>
					{renderIcons(icon, {
						BedUnderline,
						CarUnderline,
						EuroCurrencyUnderline,
						FactoryUnderline,
						ForkliftUnderline,
						HammerUnderline,
						HandheartUnderline,
						HeartHandCare,
						PlateUnderline,
						SteeringWheelUnderline,
					})}
				</Svg>
				<div className='text'> {title} </div>
			</div>
		</SectorCardImageContainer>
	);
};
// #endregion

export default SectorCardImage;
